import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import AuthGuard from './AuthGuard';

/**
 * RoleGuard - Protects routes based on user role
 * @param {Object} props
 * @param {React.ReactNode} props.children - Components to render if user has required role
 * @param {string|string[]} props.allowedRoles - Single role or array of roles that can access this route
 */
const RoleGuard = ({ children, allowedRoles }) => {
  const { user } = useAuth();

  // Wrap with AuthGuard to ensure user is authenticated first
  return (
    <AuthGuard>
      {(() => {
        // If no user, AuthGuard will handle redirect
        if (!user) {
          return null;
        }

        // Normalize allowedRoles to array
        const roles = Array.isArray(allowedRoles) ? allowedRoles : [allowedRoles];

        // Check if user's role is in allowed roles
        if (!roles.includes(user.role)) {
          // Redirect to dashboard if user doesn't have required role
          return <Navigate to="/dashboard" replace />;
        }

        // User has required role, render children
        return children;
      })()}
    </AuthGuard>
  );
};

export default RoleGuard;
